"use client";

import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";
import posthog from "posthog-js";
import { sanitizePdfMeasurement } from "@/lib/pdf-measurement";
import { sanitizeExtensionAuthEvent } from "@/lib/extension-auth-measurement";
import { acquisitionChannel, measurementRoute, sanitizeWebsiteMeasurement } from "@/lib/website-measurement";

export const PostHog = () => {
  const pathname = usePathname();
  const previousPath = useRef<string | null>(null);
  useEffect(() => {
    if (process.env.NODE_ENV === "development") return;
    try {
      posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
        api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
        ui_host: "https://us.posthog.com",
        debug: false,
        autocapture: false,
        capture_pageview: false,
        capture_pageleave: false,
        disable_session_recording: true,
        // Flags send initial person properties outside before_send; this app uses its own flags API.
        advanced_disable_flags: true,
        save_referrer: false,
        before_send: event => sanitizeWebsiteMeasurement(sanitizePdfMeasurement(sanitizeExtensionAuthEvent(event))),
      });
      window.posthog = posthog;
      // Only coarse channel/known route persist through same-browser sign-in.
      posthog.register_once({
        acquisition_channel: acquisitionChannel(window.location.search, document.referrer),
        landing_route: measurementRoute(window.location.pathname),
      });
    } catch { /* Observability cannot block the application. */ }
  }, []);
  useEffect(() => {
    if (process.env.NODE_ENV === "development" || previousPath.current === pathname) return;
    previousPath.current = pathname;
    try {
      // Question: which known entry routes progress to signup/useful actions?
      posthog.capture("$pageview", { route: measurementRoute(pathname), schema_version: 1 });
    } catch { /* Observability cannot block navigation. */ }
  }, [pathname]);
  return null;
};
